import React from "react";

export default function Aircraft({ planes }) {

  const AirplaneList = Array.isArray(planes) && planes.map((plane) => {
    return (
        <>
      <div className="card" key={plane.id}>
        <img src={plane.image} alt="Airplane" className="card-image" />
        <div className="card-content">
          <p className="airline">Airline: {plane.airline}</p>
          <p className="aircraft-model">Aircraft Model: {plane.aircraft_model}</p>
          <p className="capacity">Capacity: {plane.capacity}</p>
          <p className="departure">Departure: {plane.departure}</p>
          <p className="destination">Destination: {plane.destination}</p>
          <p className="flight-duration">Flight Duration: {plane.flight_duration}</p>
        </div>
      </div>
      </>
    );
  });

  return (
    <>
      <h1>Hello</h1>
      {AirplaneList}
    </>
  );
}
